import PropTypes from "prop-types";
import ImageWrapper from "../ImageWrapper/component";

/**
 * Author image component.
 *
 * @param {Object} props The component properties
 * @returns {JSX.Element} The AuthorImage component
 */
function AuthorImage({ src, loading }) {
    if (!src) {
        return null;
    }

    return <ImageWrapper url={src} loading={loading} type="author-image" />;
}

AuthorImage.propTypes = {
    src: PropTypes.string,
};

export { AuthorImage as default };
